var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChildrensClothing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Baby-Care-Clothes--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Baby Care Clothes Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.82 4.08 21.76 3a12 12 0 0 0 -6.69 -3 0.75 0.75 0 0 0 -0.82 0.74 2.25 2.25 0 0 1 -4.5 0A0.75 0.75 0 0 0 8.93 0a12 12 0 0 0 -6.69 3L1.18 4.08a1.75 1.75 0 0 0 0 2.47L2.6 8a1.77 1.77 0 0 0 2.25 0.17 0.25 0.25 0 0 1 0.26 0 0.24 0.24 0 0 1 0.14 0.22v12.9a2.75 2.75 0 0 0 5.5 0V18.5a1.25 1.25 0 0 1 2.5 0v2.75a2.75 2.75 0 0 0 5.5 0V8.35a0.24 0.24 0 0 1 0.14 -0.22 0.25 0.25 0 0 1 0.26 0A1.77 1.77 0 0 0 21.4 8l1.42 -1.43a1.75 1.75 0 0 0 0 -2.49ZM12 13.77a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm0 -3.51a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Zm0 -3.51a1 1 0 1 1 1 -1 1 1 0 0 1 -1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChildrensClothing);
export default ForwardRef;